module.exports = __webpack_public_path__ + "static/assets/adobe-logo.0d85b7f.png";